import { ConfirmationDialog } from "apps/web/src/componentLibrary";
import { TWTableActions } from "apps/web/src/componentLibrary/TWTableActions";
import { useSnackbar } from "apps/web/src/components/Snackbar/SnackbarContext";
import { ORGANIZATION_RECIPES } from "apps/web/src/pages/Auth/Org/FoodManagement/Utils";
import { useBulkDeleteRecipesMutation } from "apps/web/src/types";
import React, { useState } from "react";
import { useRecipesPage } from "./useRecipesPage";

/**
 * Floating bulk-delete actions bar + confirmation for the Org Recipes tab.
 * Rendered inside RecipesPageProvider so it can read selection from context.
 */
export const RecipesBulkDeleteActions = () => {
  const { tab, selectedRecipeIds, clearRecipeSelection, resetTable } = useRecipesPage();
  const { setMessage } = useSnackbar();
  const [confirmOpen, setConfirmOpen] = useState(false);

  const [bulkDeleteRecipes] = useBulkDeleteRecipesMutation({
    onCompleted: data => {
      resetTable();
      clearRecipeSelection();
      setConfirmOpen(false);
      const count = data.bulkDeleteRecipes.recipeIds.length;
      setMessage("success", `${count} recipe${count === 1 ? "" : "s"} have been deleted`);
    },
    onError: e => setMessage("error", e.message),
  });

  if (tab !== ORGANIZATION_RECIPES || selectedRecipeIds.size === 0) {
    return null;
  }

  const handleBulkDelete = () => {
    bulkDeleteRecipes({ variables: { input: { recipeIds: [...selectedRecipeIds] } } });
  };

  return (
    <>
      <TWTableActions
        selectedCount={selectedRecipeIds.size}
        onClearSelection={clearRecipeSelection}
        actions={[{ id: "delete", label: "Delete", onClick: () => setConfirmOpen(true) }]}
      />
      {confirmOpen && (
        <ConfirmationDialog
          open={confirmOpen}
          title="Delete Recipes"
          message={`Are you sure that you would like to delete ${selectedRecipeIds.size} recipe${
            selectedRecipeIds.size === 1 ? "" : "s"
          }?`}
          onCancel={() => setConfirmOpen(false)}
          onConfirm={handleBulkDelete}
          variant="containedDestructive"
        />
      )}
    </>
  );
};
